import type { CharacterAvatarSize, CharacterPortraitLayout } from "../../models/ICharacter";
import { ICharacterAvatarTokens, ICharacterPortraitSpacingTokens, ICharacterPortraitTextTokens, ICharacterPortraitTokens } from "../../models/ICharacterTokens";

const AVATAR_TOKENS: Record<CharacterAvatarSize, ICharacterAvatarTokens> = {
    xs: { diameterPx: 32, ringPx: 2, badgeDiameterPx: 12, badgeRingPx: 2, badgeOffsetPx: -2 },
    sm: { diameterPx: 48, ringPx: 2, badgeDiameterPx: 16, badgeRingPx: 2, badgeOffsetPx: -3 },
    md: { diameterPx: 72, ringPx: 3, badgeDiameterPx: 20, badgeRingPx: 2, badgeOffsetPx: -4 },
    lg: { diameterPx: 96, ringPx: 3, badgeDiameterPx: 24, badgeRingPx: 2, badgeOffsetPx: -5 },
    xl: { diameterPx: 128, ringPx: 4, badgeDiameterPx: 28, badgeRingPx: 2, badgeOffsetPx: -6 },
};

const TEXT_TOKENS: Record<CharacterAvatarSize, ICharacterPortraitTextTokens> = {
    xs: { namePx: 0, subtitlePx: 0, statPx: 0 }, // unused in HUD/compact, keep safe
    sm: { namePx: 14, subtitlePx: 12, statPx: 12 },
    md: { namePx: 16, subtitlePx: 14, statPx: 12 },
    lg: { namePx: 18, subtitlePx: 16, statPx: 12 },
    xl: { namePx: 22, subtitlePx: 20, statPx: 12 },
};

const SPACING_TOKENS: ICharacterPortraitSpacingTokens = {
    avatarToNamePx: 6,
    nameToSubtitlePx: 3,
    subtitleToStatsPx: 6,
};

export function getCharacterAvatarTokens(size: CharacterAvatarSize): ICharacterAvatarTokens {
    return AVATAR_TOKENS[size];
}

export function getCharacterPortraitTokens(size: CharacterAvatarSize, layout: CharacterPortraitLayout): ICharacterPortraitTokens {
    // Layout currently influences what is rendered, not the token values.
    // Keep the signature now so adding layout-specific adjustments later is non-breaking.
    void layout;

    return {
        avatar: AVATAR_TOKENS[size],
        text: TEXT_TOKENS[size],
        spacing: SPACING_TOKENS,
    };
}
